/**
 * O backend responde erro em dois formatos: { statusCode, data: { message } } (app.ts e controllers) e
 * { name, message } solto (guardas ensureWorkspaceSellerOrAdmin e ensureWorkspaceParty). Envelope primeiro,
 * depois o solto; mensagem vazia nos dois cai na reserva.
 */
export function errorMessageOf(error: any, fallback: string): string {
  // Em 5xx a mensagem é a exceção crua do servidor (SQL, timeout), nunca texto para a tela (T24, D1).
  if (Number(error?.response?.status) >= 500) return fallback;
  return error?.response?.data?.data?.message || error?.response?.data?.message || fallback;
}
